import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const About = () => {
  const missions = ['De la blocaj mental la claritate și direcție.', 'De la relații tensionate la conexiuni autentice.', 'De la reacție automată la alegere conștientă.'];
  return <section id="despre" className="py-24 bg-navy-dark relative overflow-hidden" data-id="element-116">
      <div className="container mx-auto px-6" data-id="element-117">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-118">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-[750px] hidden lg:block" data-id="element-119">
            {/* Main photo container - full width */}
            <div className="relative w-full h-full bg-navy border border-gold/20 overflow-hidden" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/9vjfTC9XgJyx5jdBYcqEwg/Marius_si_Ana_1.jpg" alt="Marius și Ana Cernea" className="w-full h-full object-cover object-top opacity-90" data-id="element-121" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-transparent to-transparent" data-id="element-122" />
            </div>
            {/* Decorative corner borders */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-l border-b border-gold/50" data-id="element-123" />
            <div className="absolute -top-6 -right-6 w-32 h-32 border-r border-t border-gold/50" data-id="element-124" />
            {/* Decorative floating circle top-left */}
            <div className="absolute -top-10 -left-10 w-24 h-24 rounded-full border border-gold/20" data-id="element-125" />
            {/* Decorative dots pattern */}
            <div className="absolute top-8 -right-12 opacity-30" data-id="element-126">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" data-id="element-127">
                {[0, 20, 40, 60].map(x => [0, 20, 40, 60].map(y => <circle key={`${x}-${y}`} cx={x + 10} cy={y + 10} r="2" fill="#C9A84C" data-id="element-128" />))}
              </svg>
            </div>
            {/* Decorative line accent */}
            <div className="absolute bottom-20 -left-8 w-16 h-px bg-gold/50" data-id="element-129" />
            <div className="absolute bottom-24 -left-8 w-10 h-px bg-gold/30" data-id="element-130" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-131">
            <h2 className="font-serif text-5xl font-bold text-white mb-2" data-id="element-132">
              Marius Cernea
            </h2>
            <p className="font-display text-gold text-sm font-semibold tracking-widest uppercase mb-8" data-id="element-133">
              Trainer NLP. Psihologie Aplicată. Comunicare Nonverbală.
            </p>
            <div className="space-y-6 font-sans text-textSub text-lg leading-relaxed mb-12" data-id="element-134">
              <p data-id="element-135">
                Sunt Marius Cernea și lucrez cu antreprenori, sportivi și lideri
                care vor să facă performanță, dar se simt epuizați, blocați sau
                fără direcție clară.
              </p>
              <p data-id="element-136">
                Prin tehnici moderne de NLP, adică Programare Neuro-Lingvistică,
                și psihologie aplicată, îi ghidez să înțeleagă cum funcționează
                mintea lor, să schimbe tiparele care nu mai servesc și să
                acționeze cu claritate și încredere.
              </p>
              <p data-id="element-137">
                Integrez NLP, comunicare nonverbală, profilare comportamentală
                și microexpresii într-un proces practic, nu teoretic. Am
                absolvit Facultatea de Psihologie la Universitatea Spiru Haret
                și am format sute de oameni în România prin programele NLP
                Practitioner și NeuroReset.
              </p>
              <p data-id="element-138">
                Lucrez alături de Ana Cernea, împreună aducem în sală experiență
                directă, nu concepte frumoase.
              </p>
            </div>
            <div className="bg-navy-card border border-gold/20 p-8" data-id="element-139">
              <h3 className="font-serif text-2xl text-white mb-6" data-id="element-140">
                Misiunea noastră
              </h3>
              <ul className="space-y-4" data-id="element-141">
                {missions.map((mission, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-142">
                    <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-143" />
                    <span className="font-sans text-textLight" data-id="element-144">{mission}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};